/* eslint-disable jsx-a11y/anchor-is-valid */

import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import withIntegrationCardContext from 'hoc/withIntegrationCardContext';
import Slider from 'react-slick';

const Wordpress = ({ sliderSettings }) => {
  const { img1 } = useStaticQuery(graphql`
    {
      img1: file(relativePath: { eq: "help/wordpress/wordpress3.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 95)
        }
      }
    }
  `);
  const photos = [
    {
      img: img1.childImageSharp.gatsbyImageData,
      alt: 'Wordpress Integration',
      title: 'Integrate Wordpress with LiveSession',
    },
  ];
  return (
    <>
      <Slider {...sliderSettings(photos)} className="without-dots">
        <div>
          <GatsbyImage image={photos[0].img} alt={photos[0].alt} title={photos[0].title} />
        </div>
      </Slider>
      <div className="section">
        <h2>Overview</h2>
        <p>
          WordPress is one of the most commonly used content management systems for websites. It
          offers a wide range of templates and plugins to create a professional-looking website or
          blog. We created a WordPress plugin to make it easy to start tracking your website’s
          visitors’ behavior.
        </p>
      </div>
      <div className="section">
        <h2>Benefits</h2>
        <ul className="checkmarks">
          <li>Learn more about your visitors</li>
          <li>Get insights from qualitative data</li>
          <li>Get the most out of your Wordpress website</li>
        </ul>
      </div>
      <h2>How to install</h2>
      <p>
        To install the LiveSession WordPress plugin, follow the instructions in our{' '}
        <a href="/help/how-install-on-wordpress/">help center</a>.
      </p>
    </>
  );
};

export default withIntegrationCardContext(Wordpress);

Wordpress.propTypes = {
  sliderSettings: PropTypes.func.isRequired,
};
